import { createFileRoute } from '@tanstack/react-router'
import { BillingSettingsPage } from '../components/billing-settings'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/parametres/facturation')({
  head: () => noIndexRouteHead('settingsBilling', 'fr'),
  component: BillingSettingsPage,
})
